import React from 'react'
import styled from 'styled-components'
import { imgUrl } from 'features/constants'
import { Tooltip } from '@mui/material'


export default function PredeterminedResponses({ pollData }) {
    return (
        <>
            {
                pollData.choices.map((choice, index) => (
                    <ChoiceWrapper key={index} >
                        <ChoiceText>
                            {choice.choice} ({choice.votes.length}) - { `${(choice.votes.length / pollData.participants.length * 100).toFixed(1)}%` }
                        </ChoiceText>  

                        <PersonWrapper>
                        {
                            choice.votes.map((vote, index) => (
                                <PersonImageWrapper key={index}>
                                    <Tooltip title={vote.fullName} placement="top" >
                                        <ProfilePic src={vote.profileImg.url} />
                                    </Tooltip> 
                                </PersonImageWrapper>
                            ))
                        } 
                        </PersonWrapper>
                    </ChoiceWrapper>
                ))
            }
        </>
    )
}

const ProfilePic = styled.img`
    width: 30px;
    height: 30px;
    border-radius: 50%; 
`

const PersonImageWrapper = styled.div`
    margin-right: 5px;
`

const PersonWrapper = styled.div`
    // here I would like to make the images flow nicely from left to right and then on a new line 
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 15px;


`

const  ChoiceText = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start; 
    color: var(--lightThemeFontColor);
    z-index: 0;
`;

const ChoiceWrapper = styled.div`
    padding: 10px;
    border-bottom: 1px solid #ccc;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 14px;
    font-weight: 500;
    color: var(--lightThemeFontColor);
    background-color: aliceblue;
    height: fit-content;
    border-radius: 10px;
    margin-bottom: 10px;
`
